export default "__VITE_ASSET__NKNyNjPr__"